// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xl_a bhn_a bhn_x","StrollerDetailRating__muted":"xl_b bhn_fo"};